import React, {useState} from "react";

import '../overlay.css';

// VideoOverlay.jsx
export default function VideoOverlay({ videoUrl, onClose }) {
    if (!videoUrl) return null;
  
    return (
      <div className="overlayForCovers">
        <button className="closeButton" onClick={onClose}>
          Fenster schließen
        </button>
  
        <div className="mainImage">
          <video
            controls
            autoPlay
            src={videoUrl}
            style={{
              width: '80%',
              maxHeight: '90%',
              margin: 'auto',
              display: 'block',
              borderRadius: '8px',
            }}
          />
        </div>
      </div>
    );
  }
  